export default "__VITE_ASSET__bc1b7ec8__"